import { render, staticRenderFns } from "./45-2.vue?vue&type=template&id=acc3653c&scoped=true&"
import script from "./45-2.vue?vue&type=script&lang=js&"
export * from "./45-2.vue?vue&type=script&lang=js&"
import style0 from "./45-2.vue?vue&type=style&index=0&id=acc3653c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "acc3653c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dgq/mei_bao_pro/insuranceagent-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('acc3653c')) {
      api.createRecord('acc3653c', component.options)
    } else {
      api.reload('acc3653c', component.options)
    }
    module.hot.accept("./45-2.vue?vue&type=template&id=acc3653c&scoped=true&", function () {
      api.rerender('acc3653c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/insurance/product/details/45-2.vue"
export default component.exports